import toast from 'react-hot-toast';

// REGEX
const CONNECTION_TYPE_REGEX = /Type(.*?)Deposit/i;
const INITAL_CREDIT_REGEX = /Initial\sCredit\sLimit\s\$(.*?)\s/i;

export function isPostpaidConnection(result) {
  return CONNECTION_TYPE_REGEX.exec(result)[1].trim() === 'Postpaid';
}

export function hasInitialCredit(result) {
  const match = INITAL_CREDIT_REGEX.exec(result);
  return match ? true : false;
}

export async function readFile(event) {
  const file = event.target.files[0];
  // Validating File type
  if (file && file.type !== 'application/pdf') {
    toast.error('Only PDF files are allowed.');
    return;
  }
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  return new Promise((resolve) => {
    reader.onload = async () => {
      const data = await reader.result;
      const [{ getDocument }] = await Promise.all([
        import('pdfjs-dist'),
        import('pdfjs-dist/build/pdf.worker.entry'),
      ]);
      const pdf = await getDocument(data).promise;
      const metaData = await pdf.getMetadata();
      const isSignaturesPresent = metaData.info.IsSignaturesPresent;

      let result = '';
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const items = textContent.items.filter((item) => item.str.trim());
        result += items.map(({ str }) => str).join(' ');
      }

      resolve({ result, isSignaturesPresent });
    };
  });
}

export function extractDiscountInfo(data, skuList) {
  const discountInfo = {};

  skuList.forEach((sku) => {
    // Regex for the first format
    const regex1 = new RegExp(
      `${sku}.*?\\$(\\d+\\.\\d+)\\s\\d+\\.\\d+\\s\\$(\\d+\\.\\d+)\\s\\$(\\d+\\.\\d+)`,
      's',
    );
    // Regex for the second format
    const regex2 = new RegExp(
      `${sku}.*?\\$([\\d\\.]+)\\sList Price\\s\\$([\\d\\.]+)\\sSave\\s\\$([\\d\\.]+)`,
      's',
    );

    let match = data.match(regex1);
    if (match) {
      const discount = parseFloat(match[2]);
      discountInfo[sku] = {
        discount,
      };
    } else {
      match = data.match(regex2);
      if (match) {
        const discount = parseFloat(match[3]);
        discountInfo[sku] = {
          discount,
        };
      }
    }
  });

  return discountInfo;
}

// export const readSkus = (SkuList, matchString) => {
//   const discountInfo = {};
//   const accessories = [];
//   const newAccessoriesList = [];


//   SkuList.forEach((item) => {
//     const [sku] = item;
//     const regex = new RegExp(
//       `${sku}.*?\\$\\d+\\.\\d+\\sList Price\\s\\$\\d+\\.\\d+\\sSave\\s\\$\\d+\\.\\d+`,
//       'g',
//     );
//     const matches = matchString.match(regex);
//     if (matches) {

//       matches.forEach((match, index) => {
//         const quantity =
//           (match.match(/(\d+) @/)?.[1] && parseInt(match.match(/(\d+) @/)[1], 10)) || 1;
//         const uniqueSkuKey = `${sku}_${index}`;
//         const discount = extractDiscountInfo(match, [sku])[sku]?.discount || 0;

//         accessories.push([...item, quantity, discount, uniqueSkuKey]);
//         discountInfo[uniqueSkuKey] = { discount };
//         discountInfo[sku] = { discount };

//         newAccessoriesList.push({
//           sku: item[0],
//           name: item[1],
//           cost: item[2],
//           msrp: item[3],
//           quantity,
//           discount,
//         });
//       });
//     }
//   });

//   return { accessories, discountInfo, newAccessoriesList };
// };

export const readSkus = (SkuList, matchString) => {
  const discountInfo = {};
  const accessories = [];
  const newAccessoriesList = [];

  SkuList?.forEach((item) => {
    const {sku} = item;
    // Regex for the RQ first format
    const regex1 = new RegExp(
      `${sku}.*?\\$\\d+\\.\\d+\\sList Price\\s\\$\\d+\\.\\d+\\sSave\\s\\$\\d+\\.\\d+`,
      'g',
    );
    // Regex for the RQ second format
    const regex2 = new RegExp(
      `${sku}\\s+([\\s\\S]*?)\\s+(\\d+)\\s+\\$([\\d\\.]+)\\s+[\\d\\.]+\\s+\\$([\\d\\.]+)\\s+\\$([\\d\\.]+)`,
      'g',
    );

    // Try matching the RQ first format
    let matches = matchString.match(regex1);
    if (matches) {
      matches.forEach((match, index) => {
        const quantity =
          (match.match(/(\d+) @/)?.[1] && parseInt(match.match(/(\d+) @/)[1], 10)) || 1;
        const uniqueSkuKey = `${sku}_${index}`;
        const discount = extractDiscountInfo(match, [sku])[sku]?.discount || 0;

        accessories.push([item.sku,item.name,item.cost,item.msrp, quantity, discount, uniqueSkuKey]);
        discountInfo[uniqueSkuKey] = { discount };
        discountInfo[sku] = { discount };

        newAccessoriesList.push({
          ...item,
          quantity,
          discount,
        });
      });
    } else {
      // Try matching the RQ second format
      matches = matchString.match(regex2);
      if (matches) {
        matches.forEach((match, index) => {
          const [, , quantityStr, , discountStr] = match.match(
            new RegExp(
              `${sku}\\s+([\\s\\S]*?)\\s+(\\d+)\\s+\\$([\\d\\.]+)\\s+[\\d\\.]+\\s+\\$([\\d\\.]+)\\s+\\$([\\d\\.]+)`
            )
          );
          const quantity = parseInt(quantityStr, 10);
          const discount = parseFloat(discountStr);
          const uniqueSkuKey = `${sku}_${index}`;

          accessories.push([item.sku,item.name,item.cost,item.msrp, quantity, discount, uniqueSkuKey]);
          discountInfo[uniqueSkuKey] = { discount };
          discountInfo[sku] = { discount };

          newAccessoriesList.push({
            ...item,
            quantity,
            discount,
          });
        });
      }
    }
  });

  return { accessories, discountInfo, newAccessoriesList };
};
